import React from 'react'

import {
  Check, Icon, TagComponent as Tag, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number, oneOf, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

function formatCurrency(priceCents, currency, locale) {
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(priceCents / 100)
}

function PlanOptionCard({
  name,
  tag = null,
  tagColor = 'primary',
  priceCents,
  currency,
  priceUnit,
  subtitle,
  isCurrent = false,
  isSelected = false,
  locale = 'en',
}) {
  const translate = (key, options = {}) => I18n.t(key, { ns: 'rails', lng: locale, ...options })

  return (
    <div
      className={classnames(
        'plan-option-card',
        isCurrent && 'plan-option-card--current',
        isSelected && 'plan-option-card--selected'
      )}
    >
      <div className="plan-option-card__header">
        <div className="plan-option-card__title-group">
          <span className="cgt-body-base-semibold">{name}</span>
          {tag && (
            <Tag
              color={tagColor}
              type="secondary"
              small
              className={tagColor === 'primary' ? 'plan-option-card__tag--brand' : undefined}
            >
              {tag}
            </Tag>
          )}
        </div>
        {isCurrent && (
          <span className="plan-option-card__current-indicator">
            <Icon
              svgComponent={Check}
              color="positive"
              size="small"
              notSpaced
              className="plan-option-card__current-icon"
            />
            <span className="cgt-overline-sm plan-option-card__current-label">
              {translate('subscription_management.switch_plan_modal.current_plan')}
            </span>
          </span>
        )}
      </div>
      <div className="plan-option-card__price">
        <span className="plan-option-card__price-amount cgt-heading-300">
          {formatCurrency(priceCents, currency, locale)}
        </span>
        <span className="plan-option-card__price-unit cgt-body-base">{priceUnit}</span>
      </div>
      <div className="plan-option-card__subtitle cgt-body-base">{subtitle}</div>
    </div>
  )
}

PlanOptionCard.propTypes = {
  name: string.isRequired,
  tag: string,
  tagColor: oneOf(['primary', 'grey']),
  priceCents: number.isRequired,
  currency: string.isRequired,
  priceUnit: string.isRequired,
  subtitle: string.isRequired,
  isCurrent: bool,
  isSelected: bool,
  locale: string,
}

export default PlanOptionCard
